import { useSelector } from "react-redux";

import { useTranslate } from "@similarweb/i18n-provider";

import {
    StyledSearchContainer,
    StyledSearchRow,
} from "app/pages/sales-intelligence/common-components/search-results-table";
import { selectIsContactsVisible } from "app/pages/sales-intelligence/sub-modules/contacts-tab/store/selectors";

import ContactsRevealedToggle from "../ContactsRevealedToggle/ContactsRevealedToggle";

import { StyledSearchTextBox } from "./styles";

type ContactsSearchTextBoxProps = {
    searchText: string;
    isOnlyRevealed?: boolean;
    isDisabled?: boolean;
    onSearch: (text: string) => void;
    onRevealedToggle: (isSelected: boolean) => void;
};

const ContactsSearchTextBox = ({
    searchText,
    isOnlyRevealed,
    isDisabled,
    onSearch,
    onRevealedToggle,
}: ContactsSearchTextBoxProps) => {
    const { translate } = useTranslate();
    const isContactsVisible = useSelector(selectIsContactsVisible);

    return (
        <StyledSearchRow>
            <StyledSearchContainer>
                <StyledSearchTextBox
                    onChange={onSearch}
                    isDisabled={!isContactsVisible}
                    searchText={searchText}
                    placeholder={translate("si.advanced_search.results_section.contacts.search_placeholder")}
                />

                <ContactsRevealedToggle
                    isSelected={isOnlyRevealed}
                    isDisabled={isDisabled}
                    onClick={() => onRevealedToggle(!isOnlyRevealed)}
                />
            </StyledSearchContainer>
        </StyledSearchRow>
    );
};

export default ContactsSearchTextBox;
